/**
 * Route Paths
 *
 * Public-web route definitions. The deprecated repo's route-paths.ts
 * carried the full app surface (onboarding, research, profile, etc.); the
 * public-web copy keeps only the marketing/legal/blog/press routes per
 * repo_split_web.md §6.
 */

export const ROUTES = {
  HOME: '/',
  INFO: '/info',
  CONTACT_US: '/contact-us',
  PRIVACY_POLICY: '/privacy-policy',
  TERMS_OF_SERVICE: '/terms-of-service',
  DATA_USE: '/data-use',
  DELETE_DATA: '/delete-data',
  DELETE_MY_DATA: '/delete-my-data',
  AI_BLOGS: '/ai-blogs',
  AI_BLOGS_POST: '/ai-blogs/:slug',
  PRESS: '/press',
  PRESS_BLUEPRINT_APRIL_2026: '/press/blueprint_april_2026',
  PRESS_PRESEED_OCT_2026: '/press/preseed_oct_2026',
  PRESS_DTEMPLATE: '/press/dtemplate',
  /** A product's own page: /product/adventures, /growth-curves, /commute-optimizer. */
  PRODUCT: '/product/:slug',
  NOT_FOUND: '*',

  // /legal/* surface. App store compliance and inbound links pin these URLs
  // as external API surface. Firebase Hosting serves static HTML versions
  // of every /legal/* path (generated by scripts/generate-legal-static.mjs)
  // so no-JS crawlers and the Google OAuth verification crawler see the
  // same content humans see. /legal itself is a menu indexing the rest.
  LEGAL_INDEX: '/legal',
  LEGAL_PRIVACY_POLICY: '/legal/privacy-policy',
  LEGAL_TERMS_OF_SERVICE: '/legal/terms-of-service',
  LEGAL_DATA_USE: '/legal/data-use',
  LEGAL_CONTACT_US: '/legal/contact-us',
  LEGAL_DELETE_DATA: '/legal/delete-data',
  LEGAL_DELETE_MY_DATA: '/legal/delete-my-data',
} as const;
